<div class="item-summary">
  <div class="metric">
    <span class="label">Total items</span>
    <strong class="value">{{ $summary().itemCount }}</strong>
  </div>
  @if (contractor) {
    <div class="metric">
      <span class="label">Total price</span>
      <strong class="value">{{ $totalBuy() }}</strong>
    </div>
  } @else {
    <div class="metric">
      <span class="label">Total buy price</span>
      <strong class="value">{{ $totalBuy() }}</strong>
    </div>
    <div class="metric">
      <span class="label">Total sell price</span>
      <strong class="value">{{ $totalSell() }}</strong>
    </div>
    <div class="metric" [class.positive]="$isProfit()" [class.negative]="$isLoss()">
      <span class="label">Profit</span>
      <strong class="value">{{ $profit() }}</strong>
    </div>
    <div class="metric" [class.positive]="$isProfit()" [class.negative]="$isLoss()">
      <span class="label">Margin %</span>
      <strong class="value">{{ $margin() }}</strong>
    </div>
  }
</div>
